import { render, staticRenderFns } from "./development-scale.vue?vue&type=template&id=5a902424&scoped=true&"
import script from "./development-scale.vue?vue&type=script&lang=js&"
export * from "./development-scale.vue?vue&type=script&lang=js&"
import style0 from "./development-scale.vue?vue&type=style&index=0&id=5a902424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a902424",
  null
  
)

export default component.exports